module.exports = __webpack_public_path__ + "img/1537521826.7782042b.jpg";